/**
 * Amount of orderbook rows deptchart is build upon.
 * Maximum is 1000 (determined by orderbook L2 API)
 */
export const DEPTH_CHART_ROWS_LIMIT = 1000;

export const depthChartStyle = {
  margin: {
    top: 0,
    right: 0,
    bottom: 30,
    left: 1,
    leftHalf: 0.5,
  },
};

export const MAXIMUM_ZOOM_LEVEL = 6;

export const DEPTH_CHART_CLIP_AREA_ID = 'depth-chart-area-clip';
